import { ORGANIZATION_URL } from "../restEndpoint";
import {
  httpGet,
  httpPost,
  httpPut,
} from "../../utils/httpMethods";

export const getAllOrganizations = async () => {
  return await httpGet({ url: `${ORGANIZATION_URL}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const getUpdateOrganization = async (id) => {
  return await httpPut({ url: `${ORGANIZATION_URL}/${id}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const organizationSignup = async (data) => {
  return await httpPost({
    url: `${ORGANIZATION_URL}/signup`,
    payload: data,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const organizationLogin = async (data) => {
  return await httpPost({
    url: `${ORGANIZATION_URL}/login`,
    payload: data,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const updateOrganization = async (id, data) => {
  return await httpPut({
    url: `${ORGANIZATION_URL}/${id}`,
    payload: data,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};


export const updatePlan = async (data) => {
  return await httpPost({
    url: `${ORGANIZATION_URL}/upgrade-plan`,
    payload: data,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const requestOrgPlanUpgrade = async ({ planName, requestMessage, organizationId }) => {
  return await httpPost({
    url: `${ORGANIZATION_URL}/request-plan-upgrade`,
    payload: { planName, requestMessage, organizationId },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const getUserStatistics = async () => {
  return await httpGet({ url: `${ORGANIZATION_URL}/user-statistics` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};